import * as React from 'react';

import { ReviewsBar } from './components/ReviewsBar';
import { ReviewsSnippetFooter } from './components/ReviewsSnippetFooter';
import { ReviewsSnippetHeader } from './components/ReviewsSnippetHeader';
import * as styles from './styles.css';
import { IRatingScore } from './types/rating';

interface IProps {
  elementId?: string;
  rating?: string | null;
  reviewsCount?: string | null;
  reviewsLink: string;
  scores?: IRatingScore[] | null;
  onAllButtonClick: VoidFunction;
  onWriteButtonClick: VoidFunction;
}

export function ReviewsSnippet({
  elementId,
  rating,
  reviewsCount,
  reviewsLink,
  scores,
  onAllButtonClick,
  onWriteButtonClick,
}: IProps) {
  const hasScores = Boolean(scores?.length);

  return (
    <div id={elementId}>
      <ReviewsSnippetHeader
        className={styles['header']}
        rating={rating}
        reviewsCount={reviewsCount}
        showInfoIcon={false}
      />
      {hasScores && (
        <div className={styles['bar-stack']}>
          {scores?.map(score => (
            <ReviewsBar
              key={score.id}
              className={styles['bar']}
              rating={score.score}
              title={score.name}
              fillPercent={score.fillingPercentage}
            />
          ))}
        </div>
      )}
      <ReviewsSnippetFooter
        className={styles['footer']}
        reviewsCount={reviewsCount}
        reviewsLink={reviewsLink}
        onAllButtonClick={onAllButtonClick}
        onWriteButtonClick={onWriteButtonClick}
      />
    </div>
  );
}
